import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    settingsIcon: {
      fontSize: theme.typography.pxToRem(14),
      cursor: 'pointer',
      color: COLORS.gray.gray40,
    },
  }),
  { name: 'BrandVoiceSettingsTitle' }
);
